export const svgIcons = {
  wallet: 'wallet',
  x: 'x',
  search: 'search',
}
